// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media only screen and (max-width: 600px) {\n.app-main[data-v-7b85789e] {\n    margin-bottom: 80px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
